export default __webpack_public_path__ + "static/projetistas-planta-3e81f348438072a4114b88da95701323.webp";